import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from 'core/contexts/auth';
import { CircularIndeterminate } from '@utriper/core-ui';
import { useStyles } from './styles';
import { ROUTES } from 'core/routing/routes';
import { toast } from 'react-toastify';

const LandingPage = () => {
    const classes = useStyles();
    const { refresh } = useAuth();
    const history = useHistory();

    useEffect(() => {
        const getToken = async () => {
            const token = await refresh();

            if (token) {
                history.push(ROUTES.HOME);
            } else {
                toast.error('No hay un código proporcionado, debes iniciar sesión!', {
                    position: 'top-right',
                    theme: 'colored',
                });
                window.location.href = `${process.env.REACT_APP_AUTH_CLIENT_URL}/?next=${process.env.REACT_APP_CLIENT ?? 'host'}`;
            }
        };

        getToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <main className={classes.main}>
            <CircularIndeterminate centered />
        </main>
        // <div className={classes.main}>
        //   {/* <img src={logo} className={classes.logo} /> */}
        //   <div className={classes.container}>
        //     <div className={classes.containerWrapper}>
        //       <div className={classes.imageContainer}></div>
        //     </div>
        //     {/* <div className={classes.languageContainer}>
        //       <LanguageDropDown style={{ marginRight: 0, marginLeft: 'auto' }} />
        //     </div> */}
        //     {/* <Grid2 container> */}
        //       {/* <Grid2 size={{xs: 12, md: 16}} className={classes.itemContainer}> */}
        //         <Login />
        //       {/* </Grid2> */}
        //       {/* <Grid2 size={{xs: 12, md: 16}} className={classes.itemContainer}>
        //         {/* <SignUp /> */}
        //       {/* </Grid2>  */}
        //     {/* </Grid2> */}
        //   </div>
        // </div>
    );
};

LandingPage.displayName = 'LandingPage';

export default LandingPage;
